import { putObject } from '@/utils/upload';

/**
 * 截图保存本地-针对西瓜播放器
 * document
 * player.video
 */
export function screenShot(document, video) {
  if (!video) {
    console.log('video is null');
    return;
  }
  let canvas = document.createElement('canvas');
  const canvasCtx = canvas.getContext('2d');
  const img = new Image();
  const filename = Date.now() + '.png';
  const type = 'image/png';
  canvas.width = video?.videoWidth || 600;
  canvas.height = video?.videoHeight || 337.5;
  img.onload = (function () {
    canvasCtx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL(type, 1);
    canvas = null;
    img.src = dataUrl;
    const saveLink = document.createElement('a');
    saveLink.href = dataUrl;
    saveLink.download = filename;
    const event = document.createEvent('MouseEvents');
    event.initMouseEvent(
      'click',
      false,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null,
    );
    saveLink.dispatchEvent(event);
  })();
}
/**
 *
 * 截图上传 返回地址-针对西瓜播放器
 * document
 * player.video
 */
export function screenShotAndUpload(document, video, onError, onSuccess) {
  let canvas = document.createElement('canvas');
  const canvasCtx = canvas.getContext('2d');
  const img = new Image();
  const filename = Date.now() + '.png';
  const type = 'image/png';
  canvas.width = video.videoWidth || 600;
  canvas.height = video.videoHeight || 337.5;
  let onProgress;
  img.onload = (function () {
    canvasCtx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL(type, 1);
    canvas = null;
    img.src = dataUrl;
    const file = dataURLtoFile(dataUrl, filename);
    putObject({
      filename,
      file,
      onProgress,
      callback: (err, data) => {
        if (err) {
          onError(err);
        }
        if (data) {
          const da = {
            percent: 1,
            name: filename,
            thumbUrl: `https://${data.Location}`,
            url: `https://${data.Location}`,
          };
          onSuccess(da);
        }
      },
    });
  })();
}

function dataURLtoFile(dataurl, filename) {
  // 将base64转换为文件
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
